import {
  ASRTP_ICON,
  CENTRAL_DISPATCHING_ICON,
  ELECTRICAL_INSTALLATIONS_ICON,
  ENERGY_ICON,
  INDUSTRY_ICON,
} from "@/components/icons/icons";
import { ImagesEnum } from "@/model/enum/ImagesEnum";
import { RoutesEnum } from "@/model/enum/RoutesEnum";
import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";

export const energetika = {
  nameKey: "solutions:energetika.name",
  descriptionKey: "solutions:energetika.description",
  href: `${RoutesEnum.SOLUTIONS}/${SolutionTypeEnum.ENERGETIKA}`,
  imageUrl: ImagesEnum.ENERGETIKA,
  icon: ENERGY_ICON,
  type: SolutionTypeEnum.ENERGETIKA,

  detailsPageHeroDescriptionKey:
    "solutions:energetika.detailsPageHeroDescription",
  experienceKey: "solutions:energetika.experience",
  experiencePointsKey: "solutions:energetika.experiencePoints",
  ourFocusDescriptionKey: "solutions:energetika.ourFocusDescription",
  ourFocusPoints: [
    {
      icon: ASRTP_ICON,
      titleKey: "solutions:energetika.ourFocusPoints.0.title",
      descriptionKey: "solutions:energetika.ourFocusPoints.0.description",
    },
    {
      icon: ELECTRICAL_INSTALLATIONS_ICON,
      titleKey: "solutions:energetika.ourFocusPoints.1.title",
      descriptionKey: "solutions:energetika.ourFocusPoints.1.description",
    },
    {
      icon: INDUSTRY_ICON,
      titleKey: "solutions:energetika.ourFocusPoints.2.title",
      descriptionKey: "solutions:energetika.ourFocusPoints.2.description",
    },
    {
      icon: CENTRAL_DISPATCHING_ICON,
      titleKey: "solutions:energetika.ourFocusPoints.3.title",
      descriptionKey: "solutions:energetika.ourFocusPoints.3.description",
    },
  ],
  sectionWithImage: null,
  section: [
    {
      titleKey: "solutions:energetika.section.0.title",
      descriptionKey: "solutions:energetika.section.0.description",
      sectionPointsKey: "solutions:energetika.section.0.sectionPoints",
    },
    {
      titleKey: "solutions:energetika.section.1.title",
      descriptionKey: "solutions:energetika.section.1.description",
      sectionPointsKey: "solutions:energetika.section.1.sectionPoints",
    },
    {
      subtitleKey: "solutions:energetika.section.2.subtitle",
      titleKey: "solutions:energetika.section.2.title",
      descriptionKey: "solutions:energetika.section.2.description",
      sectionPointsKey: "solutions:energetika.section.2.sectionPoints",
    },
  ],
  solutionsForTopic: [
    {
      titleKey: "solutions:energetika.solutionsForTopic.title",
      descriptionKey: "solutions:energetika.solutionsForTopic.description",
      pointsKey: "solutions:energetika.solutionsForTopic.points",
    },
  ],
};
